import React, { useState } from "react";
import ProductSheetsList from "./ProductSheetsList";
import ProductSheetModal from "./ProductSheetModal";
import { useT } from "../../i18n";

const ProductSheetPage: React.FC = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");
  const [isNewSheetModalOpen, setIsNewSheetModalOpen] = useState(false);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header - exact match from release page */}
      <header className="flex items-center justify-between h-20 px-8 bg-white border-b border-gray-200">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            {t("productSheets.title")}
          </h2>
          <p className="text-sm text-gray-500">
            {t("productSheets.subtitle")}
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setIsNewSheetModalOpen(true)}
            data-testid="upload-sheet-btn"
            className="px-5 py-2.5 flex items-center bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium shadow-sm"
          >
            <i className="fa-solid fa-upload mr-2"></i>
            {t("productSheets.uploadSheet")}
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 p-8">
        {/* Product Sheets List with integrated search and controls */}
        <ProductSheetsList
          searchQuery={searchQuery}
          onSearchChange={handleSearch}
        />

        {/* New Product Sheet Modal */}
        <ProductSheetModal
          isOpen={isNewSheetModalOpen}
          onClose={() => setIsNewSheetModalOpen(false)}
          onSuccess={() => {
            // The query will be automatically refetched due to react-query cache invalidation
            // in the useCreateProductSheet hook, so no need to manually refetch here
          }}
        />
      </main>
    </div>
  );
};

export default ProductSheetPage;
